module.exports = __webpack_public_path__ + "static/img/graphic.d614b4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/graphic.jpg
// module id = fRY/
// module chunks = 1